import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { WhatsAppFab, BackToTop, CookieConsent } from "./FloatingUtilities";
import { Toaster } from "./ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white font-inter text-zinc-900">
      <Navbar />
      <main className="pt-16">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
      <BackToTop />
      <CookieConsent />
      <Toaster position="top-right" />
    </div>
  );
}
